<template>
  <div class="section">
        <div class="container">
            <h1 class="title">Your profile</h1>
        </div>

        <div class="section">
            <div class="container" v-if="profile.name">
                <p><strong>Name:</strong> {{profile.name}}</p>
                <p><strong>Email:</strong> {{profile.email}}</p>
            </div>
        </div>

        <!-- <div class="container" v-if="myProductGroups">
            <h2 class="subtitle">ProductGroups I'm watching</h2>
            <ProductGroupCards :items="myProductGroups" :watching="true" />
        </div>

        <div class="container" v-if="myProducts">
            <h2 class="subtitle">Products I'm watching</h2>
            <ProductCards :items="myProducts" :watching="true" />
        </div> -->

  </div>
</template>

<script>
import Api from '@/config/Api'
import { mapState } from 'vuex'

// import ProductGroupCards from '../cards/ProductGroupCards';
// import ProductCards from '../cards/ProductCards';

export default {
    name: 'account',
    data () {
      return {
        /* myProductGroups: [],
        myProducts: [] */
      }
    },
    components: {
        // ProductGroupCards,
        // ProductCards
    },
    computed: {
        ...mapState({profile: state => state.user.profile}),
    },
    created() {
        /* Api().get('/api/user/productGroupsAndProducts')
        .then(response => {
            this.myProductGroups = response.data.productGroups;
            this.myProducts = response.data.products;
        }); */
    },
  }
</script>


<style scoped>
/* .headline{
    margin-top: 1em;
    display: flex;
    img {
      height: 80px;
      width: 80px;
      border-radius: 50%;
    }
} */
</style>



// WEBPACK FOOTER //
// src/components/accounts/Account.vue